import {Navigate, useNavigate, useParams} from "react-router-dom";
import React, {useEffect} from "react";
import RecipeEditContent from "../../../components/cooking/recipe/edit";

export default function RecipeEditPage() {
    const {id} = useParams();

    const [needsRedirect, setNeedsRedirect] = React.useState(false);

    useEffect(() => {
        document.title = "Edit Recipe - Hoarfroster";
    }, [id]);

    return (
        <main>
            <div className="container">
                <div className="content space-y-4">
                    <RecipeEditContent id={id!} onSubmitted={() => {
                        setNeedsRedirect(true)
                    }}/>

                    {needsRedirect && <Navigate to={"/recipe" + id}/>}
                </div>

                <div className="sidebar space-y-2">
                    <h2>Tips</h2>
                    <p>如果没有登录，你可能无法看得到图片。</p>
                </div>
            </div>
        </main>
    );
}